/* eslint-disable camelcase */
const STORAGE_KEY = 'spotlight_onboarding_analytics_v1';

const getStorage = () => {
  if (typeof window === 'undefined') return null;

  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
};

const readState = () => {
  const storage = getStorage();
  if (!storage) return {};

  try {
    return JSON.parse(storage.getItem(STORAGE_KEY) || '{}') || {};
  } catch {
    return {};
  }
};

const writeState = (nextState) => {
  const storage = getStorage();
  if (!storage) return nextState;

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(nextState));
  } catch {
    // Analytics state should never block onboarding.
  }

  return nextState;
};

export const resetOnboardingAnalyticsState = () => writeState({
  started_at: Date.now(),
  completed_steps: [],
});

export const updateOnboardingAnalyticsState = (properties = {}) => {
  const current = readState();
  return writeState({ ...current, ...properties });
};

export const markOnboardingStepCompleted = (step) => {
  if (!step) return readState();

  const current = readState();
  const completedSteps = Array.isArray(current.completed_steps)
    ? current.completed_steps
    : [];

  return writeState({
    ...current,
    completed_steps: completedSteps.includes(step)
      ? completedSteps
      : [...completedSteps, step],
  });
};

export const getOnboardingAnalyticsState = () => readState();

export const getOnboardingElapsedSeconds = (fallbackStartedAt) => {
  const state = readState();
  const startedAt = Number(state.started_at || fallbackStartedAt || 0);

  if (!startedAt) return null;

  const elapsedMilliseconds = Date.now() - startedAt;
  if (elapsedMilliseconds < 0) return null;

  return Math.round(elapsedMilliseconds / 1000);
};
